import {TEXT_WRAPPER_END, TEXT_WRAPPER_START} from "../../constants";
import {ITextRange} from "../dynamic-variable/index";
import {KOSubscriptionTracker} from "../../util/KOSubscriptionTracker";
import {moment} from 'moment';

export namespace nsForm {
    export const ALL_PARTS: TFormPartName[] = ['AREABOX', 'BUTTON', 'CHECKBOX', 'DATEBOX', 'INPUTBOX', 'LISTBOX', 'RADIO'];
    export const ALL_TYPES: TInputType[] = ["email", "number", "password", "tel", "text", "url"];
    export const DATE_FORMAT = ['DD.MM.YYYY', 'DD.MM.YYYY hh.mm.ss'];

    export const getRawFormPart = (index: number, text: string): IField => {
        let start: number = index,
            end: number = index,
            counter: number = 0,
            html: string = '',
            i: number = index
        ;
        if (text.charAt(index) !== TEXT_WRAPPER_START) {
            for (i; i < text.length; i++) {
                if (text.charAt(i) == TEXT_WRAPPER_START) {
                    html = text.substring(start, i);
                    end = i - 1;
                    break;
                }
            }
        } else {
            for (i; i < text.length; i++) {
                if (text.charAt(i) == TEXT_WRAPPER_START) {
                    counter += 1;
                }
                if (text.charAt(i) == TEXT_WRAPPER_END) {
                    counter -= 1;
                }

                if (counter === 0) {
                    html = text.substring(start, i + 1);
                    end = i;
                    break;
                }
            }
        }

        if (!html) {
            start = index;
            end = text.length;
            html = text.substring(start);
        }

        return {start, end, html};
    }

    export function getParameters(textRange: ITextRange): string[] {
        let counter = 0;
        const values: string[] = [];
        const str = textRange.str;
        let last = 0;
        for (let i = 0; i < str.length; i++) {
            const char = str.charAt(i);
            if (char == TEXT_WRAPPER_START) counter++;
            if (char == TEXT_WRAPPER_END) counter--;
            if ((char == ';') && counter == 0) {
                values.push(str.substring(last, i));
                last = i + 1;
            }
        }
        values.push(str.substring(last, str.length));
        return values;
    }


    export function str2Bool(str: string): boolean {
        return str.toLowerCase() === 'true';
    }

    export function bool2Str(bool: boolean): string {
        return String(bool);
    }

}